// Warning: BE return 400 if we request more than ItemsPerPage for guest user
export const CollectionsPerPage = 47;
export const ItemsPerPage = 48;
export const ItemsPerPageGuest = 24;
